// extracted by mini-css-extract-plugin
export default {"wrap":"tXzwmuS854EI2l2Filay","noMargin":"UDmmPCydapVkeSB9yswl"};